import { Box, Stack, TextField } from "@mui/material";
import { Avatar } from "@src/appV2/lib/Avatar";
import { Button } from "@src/appV2/redesign/components/Button";
import { Dropdown } from "antd";

import { Icon } from "@src/appV2/redesign/components/Icon";
import { Text } from "@src/appV2/redesign/components/Text";
import { AccountSwitcherMenuWorkplaceMobile } from "./AccountSwitcherDropdownWorkplace";
import { useAccountSwitcher } from "../../Shared/AccountSwitcher/useAccountSwitcher";
import { AccountSwitcherDropdownAdminMobile } from "./AccountSwitcherDropdownAdmin";

export function AccountSwitcherMobile() {
  const {
    switcherTitle,
    switcherSubtitle,
    displayAdminSwitcher,
    dropdownVisible,
    onAdminSearchBarEntered,
    onDropdownButtonClicked,
    onDropdownMouseLeave,
    workerDetails,
    workplaceDetails,
    onSearchChanged,
    onUserClicked,
    onAdminClicked,
  } = useAccountSwitcher();

  return (
    <Dropdown
      overlay={() => (
        <Box
          sx={(theme) => ({
            maxHeight: "60vh",
            overflowY: "auto",
            background: theme.palette.background.paper,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.4)",
            padding: 3,
          })}
          onMouseLeave={onDropdownMouseLeave}
        >
          {displayAdminSwitcher ? (
            <AccountSwitcherDropdownAdminMobile
              workerDetails={workerDetails}
              workplaceDetails={workplaceDetails}
              onUserClicked={onUserClicked}
              onAdminClicked={onAdminClicked}
            />
          ) : (
            <AccountSwitcherMenuWorkplaceMobile
              workplaceDetails={workplaceDetails}
              onUserClicked={onUserClicked}
            />
          )}
        </Box>
      )}
      visible={dropdownVisible}
      placement="bottomRight"
      overlayStyle={{ zIndex: 1300 }}
      getPopupContainer={(trigger) => trigger.parentElement || document.body}
    >
      {displayAdminSwitcher ? (
        /* TODO: replace text field, with redesigned component */
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          color="secondary"
          sx={(theme) => ({
            "& .MuiOutlinedInput-input": {
              color: theme.palette.navbar?.sectionTitle,
            },
          })}
          placeholder="Search agents or workplaces..."
          onClick={onAdminSearchBarEntered}
          onChange={(event) => {
            onSearchChanged(event.target.value);
          }}
        />
      ) : (
        <Button
          variant="outlineInverted"
          sx={{
            height: "100%",
            flexGrow: 1,
            flexShrink: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onClick={onDropdownButtonClicked}
        >
          <Avatar
            name={switcherTitle}
            sx={(theme) => ({
              bgcolor: theme.palette.navbar?.avatarBackground,
              color: theme.palette.navbar?.avatarText,
              flexShrink: 0,
            })}
          />
          <Stack direction="column" flex={1} minWidth={0}>
            <Text
              variant="body1"
              textAlign="left"
              color={(theme) => theme.palette.navbar?.userName}
            >
              {switcherTitle}
            </Text>
            {switcherSubtitle && (
              <Text variant="caption" textAlign="left">
                {switcherSubtitle}
              </Text>
            )}
          </Stack>
          <Icon
            type="caret-bottom"
            sx={(theme) => ({
              color: theme.palette.button?.outline.inverted.hover.color,
              flexShrink: 0,
            })}
          />
        </Button>
      )}
    </Dropdown>
  );
}

/*        */
